module.exports = __webpack_public_path__ + "media/stone_3.f7631442.webm";